import cookies from "../utils/cookies";
import {TemplatesWebFrontendRequest} from "services-comun-ed/modules/services/templates/frontend-web";

declare global {
    interface Window {
        dataLayer: any;
    }
}

export class ProgressiveWebAppController {

    /* INSTANCE */
    public static instance: ProgressiveWebAppController;
    private deferredPrompt: any;

    /* STATIC */
    public static async build(): Promise<void> {
        ProgressiveWebAppController.instance = new this();
    }

    private constructor() {
        if (!cookies.get("popupShow")) {
            window.addEventListener('beforeinstallprompt', (e) => {
                e.preventDefault();
                this.deferredPrompt = e;
            });
        }
    }

    public async showInstallPromotion(): Promise<void> {
        if (!cookies.get("popupShow")) {
            const el = await this.createBar();
            el.style.display = "flex";
            const halfScreenHeight = (window.innerHeight / 2) - 83;

            setTimeout(() => {
                el.style.top = `${halfScreenHeight}px`;
                this.sendEventShowPopup();
            }, 100);
        }
    }

    private async createBar(): Promise<HTMLElement> {
        const data = await TemplatesWebFrontendRequest.popupPWA();
        const parser = new DOMParser();
        const html = parser.parseFromString(data.data, "text/html");
        const div = html.body.firstElementChild as HTMLElement;

        document.body.appendChild(div);

        div.querySelector('.btn-close-pwa')?.addEventListener("click", () => {
            div.style.display = 'none';
            this.setCookie();
            this.sendEventDontShow();
        });

        div.querySelector('.btn-add-pwa')?.addEventListener("click", () => {
            if (this.deferredPrompt) {
                this.deferredPrompt.prompt();
                this.deferredPrompt.userChoice.then((choiceResult: any) => {
                    if (choiceResult.outcome === "accepted") {
                        this.setCookie();
                        this.sendEventCreatePWA();
                    }
                    this.deferredPrompt = null;
                });
            }
        });

        return div;
    }

    private async sendEventShowPopup(): Promise<void> {
        window.dataLayer.push({
            event: 'ga4_event',
            ga4_action_name: 'pwa',
            ga4_event_name: 'popup',
            ga4_tag_name: 'mostrar'
        });
    }

    private async sendEventDontShow(): Promise<void> {
        window.dataLayer.push({
            event: 'ga4_event',
            ga4_action_name: 'pwa',
            ga4_event_name: 'popup',
            ga4_tag_name: 'no_mostrar'
        });
    }

    private async sendEventCreatePWA(): Promise<void> {
        window.dataLayer.push({
            event: 'ga4_event',
            ga4_action_name: 'pwa',
            ga4_event_name: 'popup',
            ga4_tag_name: 'aceptado'
        });
    }

    private setCookie(): void {
        cookies.set("popupShow", "true", new Date(Date.now() + 31536000000), undefined, "/"); // 1 año duración
    }

}
